import Layout from '../components/Layout';
import PublicationList from '../components/PublicationList';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">Publications</h2>

      <PublicationList/>

      <p>Paper on LMM calibration and simulation with Mathlogic's AAD library is planned for release soon.</p>
      <h2 className="mb-30">Conferences</h2>

      
      <p>
        2020 August 11. 23rd European Workshop on Automatic Differentiation <a href="http://www.autodiff.org/?module=Workshops&submenu=EuroAD%2F23%2Fprogramme">The First Virtual, Worldwide Workshop on Automatic Differentiation</a>
      </p>
      <p>
        2020 March 21. Quant Summit Europe <a href="https://events.risk.net/quantsummiteurope/speakers-2020">Risk.net Events</a>
      </p>
      <p>
        2019 December 11. Intel Software Development Workshop for Enterprise, HPC and AI <a href="https://www.youtube.com/watch?v=jHc62F4QmwQ">Youtube video</a>. 
      </p>
      <p>
        2019 November 15. Presented : Breaking the Primal Barrier, <a href="https://qiconference.com/">Quant Insights AI, Machine Learning and Risk, London</a>. 
      </p>
      <p>
        2019 October 15. Presented the idea behind #AAD Compiler at <a href="https://wbstraining.com/events/qfc/conference-day-2/">the 15th WBS conference(XVA, AAD stream)</a> in Rome. 
      </p>
    </div>
  </Layout>
)